import React, {useEffect, useState} from 'react';
import { removeHoursFromDate } from '@/utils/functions/formatTimeDate';
import { useSelector } from 'react-redux';
import ModalAddQuestion from '@/views/components/SimpleTextAdivse/Modals/ModalAddQuestion';
import ModalCloseQuestion from '@/views/components/SimpleTextAdivse/Modals/ModalCloseQuestion';
import CustomSelect from '@/views/components/CustomSelect/CustomSelect';
import InfoIcon from '@/assets/icons/simpleTextAdvices/info_icon.svg';
import api from "@/services/api";
import styles from '@/views/components/SimpleTextAdivse/Question/Question.module.scss';
import Alert from '@/views/components/Alert/Alert';
import TextEditor from '@/views/elements/TextEditor';
import { CheckPermission } from '@/utils/permissions/permissions';

const Question = ({question, getQuestion}) => {
	const [ showModalAdd, setShowModalAdd ] = useState(false);
	const [ showModalClose, setShowModalClose ] = useState(false);
	const [ editQuestion, setEditQuestion ] = useState(null);
	const [ categories, setCategories ] = useState([]);
	const [ activeCategorie, setActiveCategories ] = useState(1);
	const [ answerContent, setAnswerContent ] = useState('');
	const [ showEditor, setShowEditor ] = useState(false);
	const [ alert, setAlert ] = useState(null);

	const { dict, ppj } = useSelector(state => state.app);
	
	const user = useSelector((state) => state.auth.user);

	const userRole = user && user.role;
	const isEditor = userRole && (userRole === 'editor');
	const noAnswer = question.answer && answerContent;

	const {
		id,
		status: {code: statusQuestion},
		category,
		content,
		textFragment,
		createdOn,
		answer,
		closed,
		published,
	} = question;

	const getQuestionStatus = (code, isPublished) => {
		if ((code === "answered-internal" || code === 'answered-external') && isPublished) {
			return dict.simpleTextAdvices.question.published;
		} else if ((code === "answered-internal" || code === 'answered-external') && !isPublished) {
			return dict.simpleTextAdvices.question.unpublished;
		} else if (code === "submitted") {
			return dict.simpleTextAdvices.question.waiting;
		} else if (code === "in-progress") {
			return dict.simpleTextAdvices.question.inProgress;
		}
	};

	const getAnswerAuthor = (answerObj) => {
		if(answerObj?.externalAuthor) {
			return <p className={ styles['question__advise__advisor'] }>{answerObj.externalAuthor.forename} {answerObj.externalAuthor.surname}</p>;
		} else if (answerObj?.author?.displayName) {
			return <p className={ styles['question__advise__advisor'] }>{answerObj.author.displayName}</p>;
		} else {
			return '';
		}
	};

	const showEditAnswerButton = CheckPermission("canManageQuestions", userRole) && statusQuestion != 'in-progress';
	const showEditQuestionButton = CheckPermission("canManageQuestions", userRole) && statusQuestion === 'submitted' && !published && !closed ;
	const showUAMButton = ppj?.externalMode && CheckPermission("canManageQuestions", userRole) && statusQuestion != 'in-progress' && statusQuestion === 'submitted';
	const showPublishButton = CheckPermission("canManageQuestions", userRole) && statusQuestion != 'in-progress' && answer;
	const showCloseButton = CheckPermission("canManageQuestions", userRole) && (statusQuestion === 'answered-internal' || statusQuestion === 'answered-external') && !closed;

	const handleEditQuestion = () => {
		setEditQuestion(question);
		setShowModalAdd(true);
	};

	const getCategories = async() => {
		const {data} = await api.get('/questions/categories');

		const newCategories = data.map(cat => ({
			id: cat.id,
			label: cat.name,
			value: cat.id,
		}));

		setCategories(newCategories);
		setActiveCategories(newCategories[0]);
	};

	const handleChangeCategorie = (item) => {
		setActiveCategories(item);
	};

	const answerAdvice = async () => {

		const dataToSend = {
			categoryId: activeCategorie.id,
			content: answerContent,
		};

		try {
			if(noAnswer) {
				const {data} = await api.put(`/questions/${id}/answer`, dataToSend);
				if(data) {
					getQuestion(id);
					setShowEditor(false);
					setAlert({content: dict.simpleTextAdvices.question.alert.added, variant: 'success'});
				}
			
			} else {
				const {data} = await api.post(`/questions/${id}/answer`, dataToSend);
				if(data) {
					getQuestion(id);
					setShowEditor(false);
					setAlert({content:  dict.simpleTextAdvices.question.alert.answered, variant: 'success'});
				}
				
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleUAM = async () => {
		try {
			const {data} = await api.put(`/questions/${id}/send`, {content: content, textFragment: textFragment});
			if(data) {
				getQuestion(id);
				setAlert({content: dict.simpleTextAdvices.question.alert.uam, variant: 'info'});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handlePublish = async () => {
		try {
			const {data} = await api.put(`/questions/${id}/${published ? 'unpublish' : 'publish'}`);
			if(data) {
				getQuestion(id);
				setAlert({content: published ? dict.simpleTextAdvices.question.alert.unpublished : dict.simpleTextAdvices.question.alert.published, variant: 'success'});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleCloseAlert = () => {
		setAlert(null);
	};

	const handleCloseModalClose = () => {
		setShowModalClose(false);
	};

	useEffect(() => {
		getCategories();
	}, []);
	
	useEffect(() => {
		if(answer?.content) {
			setAnswerContent(answer.content);
			
		}
	}, [ answer ]);

	useEffect(() => {
		if(category && categories) {
			const activeCat = categories.filter(cat => cat.id === category.id);
			setActiveCategories(activeCat[0]);
		}

	}, [ category, categories ]);

	return (
		<>
			{showModalAdd && <ModalAddQuestion 
				editQuestion={ editQuestion }
				getQuestion={ getQuestion }
				showModalAdd={ showModalAdd }
				setShowModalAdd={ setShowModalAdd }
				setAlert={ setAlert }
			/>}
			{showModalClose && 
			<ModalCloseQuestion 
				showModalClose={ showModalClose }
				setShowModalCloce={ setShowModalClose }
				handleClose={ handleCloseModalClose }
				getQuestion={ getQuestion }
				id={ question.id }
				setAlert={ setAlert }
			/>}
			<div className={ styles['question'] }>
				{alert && <Alert 
					variant={ alert.variant }
					alertContent={ alert.content }
					closeAction={ ()=> handleCloseAlert() }
				/>}
				<p className={ styles['question__title'] }>
					{dict.simpleTextAdvices.question.title} {id}
				</p>
				<div className={ styles['question__metaData'] }>
					<div className={ styles['question__metaData__info'] }>
						<div className={ styles['question__metaData__item'] }>
							<span className={ styles['question__status-label'] }>{dict.simpleTextAdvices.question.statusLabel} </span> <span className={ styles['question__status'] }>{getQuestionStatus(statusQuestion, published, answer, closed)}</span>
						</div>
						{category?.name && <div className={ styles['question__metaData__item'] }>
							<span className={ styles['question__status-label'] }>{dict.simpleTextAdvices.question.category}</span><div className={ styles['question__category-box'] }>{category.name}</div>
						</div>}
					</div>
					<div className={ styles['question__metaData__buttons'] }>
						{showEditQuestionButton && <button className='button__blue'
							onClick={ ()=> handleEditQuestion() } >
							{dict.simpleTextAdvices.question.button.editQuestion}
						</button>}
						{showEditAnswerButton && <button className='button__blue'
							onClick={ ()=> setShowEditor(true) } >
							{(noAnswer) ? dict.simpleTextAdvices.question.button.editAnswer : dict.simpleTextAdvices.question.button.giveAnswer}
						</button>} 
						{showCloseButton && <button className='button__blue'
							onClick={ ()=> setShowModalClose(true) } >
							{dict.simpleTextAdvices.question.button.close}
						</button>}
						{showPublishButton && <button className='button__blue'
							onClick={ ()=> handlePublish() } >
							{published ?  dict.simpleTextAdvices.question.button.unpublish : dict.simpleTextAdvices.question.button.publish}
						</button>}
						{showUAMButton && <button className='button__blue'
							onClick={ ()=> handleUAM() } >
							{dict.simpleTextAdvices.question.button.uam}
						</button>}
					</div>
				</div>
				<div className={ styles['question__description-container'] }>
					<p className={ styles['question__description'] }>{content}</p>
					<p className={ styles['question__description-part'] }>{dict.simpleTextAdvices.question.fragment}</p>
					<div className={ styles['question__part-box'] }>
						<p className={ styles['question__part-text'] }>
							{textFragment}
						</p>
					</div>
					<p className={ styles['question__date'] }>{dict.simpleTextAdvices.question.date} {removeHoursFromDate(createdOn).replaceAll('-', '.')}</p>
				</div>
				<div className={ styles['question__advise-bar'] }>
					<p className={ styles['question__advise__label'] } >{dict.simpleTextAdvices.question.advice}</p>
					{answer?.createdOn && <p className={ styles['question__advise__date'] }>{dict.simpleTextAdvices.question.adviceDate} {removeHoursFromDate(answer.createdOn).replaceAll('-', '.')}</p>}
				</div>
				{showEditor && 
				<div className={ styles['question__editor'] }>
					<div className={ styles['question__editor__select'] }>
						<CustomSelect
							options={ categories } 
							value={ activeCategorie }
							onChange={ handleChangeCategorie }
							placeholder=""
							className='question__select__category'
							label={ dict.simpleTextAdvices.question.categoryLabel }
						/>
					</div>
					<p className={ styles['question__editor__label'] }>{dict.simpleTextAdvices.question.contentLabel}</p>
					<TextEditor
						defaultText={ answerContent }
						setFieldContent={ setAnswerContent }
						minHeight={ 100 }
						setAutoFocus
						buttonList={ [ [ 'bold' ], [ 'list' ] ] }
						maxCharCount={ 4000 }
					/>
					<div className={ styles['question__editor__buttons'] }>
						<button 
							className='button__transparent' 
							onClick={ ()=> setShowEditor(false) }
						>
							Anuluj
						</button>
						<button 
							disabled={ answerContent.length < 1 || answerContent === '<p><br></p>' }
							className='button__blue'
							onClick={ ()=> answerAdvice() }
						>
							{noAnswer ? dict.simpleTextAdvices.question.button.editAnswer : dict.simpleTextAdvices.question.button.giveAnswer}
						</button>
					</div> 
				</div>
				}
				{ !showEditor && (answer ? 
					<>
						{answerContent && <p className={ styles['question__advise__content'] }
							dangerouslySetInnerHTML={ {__html: answerContent} } />}
						<div className={ styles['question__advise__advisor-container'] }>
							<p className={ styles['question__advise__advisor-label'] }>{dict.simpleTextAdvices.question.advisor}</p> 
							{getAnswerAuthor(answer)}
						</div>
					</> : <div className={ styles['question__no-advise'] }>					
						<img src={ InfoIcon }
							alt={ dict.simpleTextAdvices.question.alt.info }/>
						<p className={ styles['question__no-advise__text'] }>
							{isEditor ? dict.simpleTextAdvices.question.noAdviceEditor : dict.simpleTextAdvices.question.noAdviceAdmin}
						</p>
					</div>)}
			</div>
		</>
	);
};

export default Question;